module.exports = "/packs/images/svg/ireland/facilities/drop_in~68825325f9438bb852f6d107350d9b52.svg";